import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, FileUp, Sparkles, Mail } from "lucide-react";
import { PublicHeader } from "../components/PublicHeader";
import { SiteFooter } from "../components/SiteFooter";
import { ResumeReviewCard } from "../components/ResumeReviewCard";
import { api, formatApiError } from "../lib/api";

const STEPS = [
  { icon: CreditCard, title: "1. Pay securely", text: "One-off A$207 through Stripe. No account, no membership, no strings — discount codes accepted at checkout." },
  { icon: FileUp, title: "2. Send us your CV", text: "Upload it right on the confirmation page (or email it to hello@theditchcareers.com.au). Rough and outdated is fine — that's the point." },
  { icon: Sparkles, title: "3. Reviewed, rewritten, signed off", text: "Our AI drafts your new ATS-friendly, Australian-market CV and a real recruiter reviews and signs it off before it lands in your inbox — within 48 hours." },
];

export default function CVReview() {
  const [payBusy, setPayBusy] = useState(false);

  const buy = async () => {
    if (payBusy) return;
    setPayBusy(true);
    try {
      const { data } = await api.post("/public/cv-review-checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatApiError(e));
      setPayBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#fcfbf8]">
      <PublicHeader />
      <section className="pt-32 pb-16 max-w-7xl mx-auto px-6" data-testid="cv-review-page">
        <p className="font-accent text-lg sm:text-xl text-[#7C8514]">CV ready in 48 hours</p>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0d2f4d] tracking-tight leading-none max-w-3xl">
          Resume Review <span className="font-accent font-medium">& Builder</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-[#51637a] max-w-xl leading-relaxed">
          Just want your CV sorted — no recruiters, no talent pool, no sign-up? This is that.
          Your CV, rewritten for the Australian market and signed off by a real recruiter, back in your inbox within 48 hours.
        </p>
        <div className="mt-12">
          <ResumeReviewCard testId="cv-review-page-card"
            ctaLabel={payBusy ? "Redirecting..." : "Get my CV reviewed"} onAction={buy} />
        </div>
        <div className="mt-16 grid sm:grid-cols-3 gap-8" data-testid="cv-review-steps">
          {STEPS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="ditch-card p-7">
              <Icon size={24} className="text-[#7C8514]" />
              <h3 className="font-heading font-bold text-[#0d2f4d] text-lg mt-4">{title}</h3>
              <p className="text-sm text-[#51637a] mt-2 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
        <p className="mt-10 flex items-center gap-2 text-sm text-[#51637a]">
          <Mail size={15} className="text-[#7C8514]" /> Questions first? Email hello@theditchcareers.com.au — happy to help.
        </p>
      </section>
      <SiteFooter />
    </div>
  );
}
